/**
 * Calculate estimated reading time for blog content
 * @param content - Markdown or plain text content
 * @param wordsPerMinute - Average reading speed (default: 225 words/min)
 * @returns Estimated reading time in minutes
 */
export const calculateReadTime = (content: string, wordsPerMinute: number = 225): number => {
  // Remove markdown syntax for accurate word count
  const plainText = content
    .replace(/!\[.*?\]\(.*?\)/g, '') // Remove images
    .replace(/\[.*?\]\(.*?\)/g, '') // Remove links
    .replace(/[#*_~`]/g, '') // Remove markdown symbols
    .replace(/\n/g, ' '); // Replace newlines with spaces
  
  const words = plainText.trim().split(/\s+/).length;
  const minutes = Math.ceil(words / wordsPerMinute);
  
  return Math.max(1, minutes); // Minimum 1 minute
};

/**
 * Format reading time for display
 * @param minutes - Reading time in minutes
 * @returns Formatted string (e.g., "5 min read")
 */
export const formatReadTime = (minutes: number): string => {
  return `${minutes} min read`;
};
